<template>
  <div id="accordion" role="tablist" aria-multiselectable="false">
    <div v-for="(step, key) in data" :key="key" class="card my-3">
      <div class="card-header d-flex align-items-center justify-content-between" role="tab" :id="'accordion-title-'+key">
        <h4 class="mb-0">
          {{step.title}}
        </h4>
        <a :class="((key==0)?'':'collapsed')" role="button" data-toggle="collapse" :href="'#accordion-body'+key" aria-expanded="true" :aria-controls="'accordion-body'+key">
          <i :data-index="key" class="fa"></i>
        </a>
      </div>
      <div :id="'accordion-body'+key" :class="'collapse'+((key==0)?' show':'') " role="tabpanel" :aria-labelledby="'accordion-title-'+key" data-parent="#accordion">
        <div class="card-body">
          <form-helper :data="step.body" :translations="translations"  tooltip-position="left" :show-icons-in-inputs="false"></form-helper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "form-helper-accordion",
        props: {
            data: {type: Array, required: true},
            method: {type: String, default: "post" },
            action: {type: String, default: "" },
            success: {type: String, default: "" },
            back: {type: String, default: "" },
            translations: {type: Object, default: function(){ return {}; }},
            aspect: {type: Object, default: function(){ return {}; }},
            location: {type: Object, default: function(){ return {}; }},
        }
      }
</script>
